import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export interface FilterParamsItem {
  field: string;
  value: (string | number)[];
}
export type DomainOptionItem = {
  value: string;
  key: string;
  abbreviation: string;
};

export type Language = "en" | "jp";
type ConfigStore = {
  language: Language;
  updateLanguage: (data: Language) => void;
  domain: DomainOptionItem;
  updateDomain: (data: DomainOptionItem) => void;
  domains: DomainOptionItem[];
  updateDomains: (data: DomainOptionItem[]) => void;
  privilege: any[];
  updatePrivilege: (data: any[]) => void;
  filter: FilterParamsItem[] | null;
  updateFilter: (data: FilterParamsItem[]) => void;
};


type ConfigLangugeStore = {
  language: string;
  // updateLanguage: (data: string) => void;
};


export const useConfigStore = create<ConfigStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        language: "en",
        updateLanguage(data: Language) {
          set((state) => {
            state.language = data;
          });
        },
        domain: {} as DomainOptionItem,
        updateDomain: (data) => {
          set((state) => {
            state.domain = data;
          });
        },
        privilege: [],
        updatePrivilege: (data) => {
          set((state) => {
            state.privilege = data;
          });
        },
        domains: [],
        updateDomains: (data) => {
          set((state) => {
            state.domains = data;
          });
        },
        filter: [],
        updateFilter(data) {
          set((state) => {
            state.filter = data;
          });
        },
      }))
    ),
    {
      name: "global-config-store",
      partialize: (state) => ({
        domain: state.domain,
        privilege: state.privilege,
      }),
    }
  )
);

type TemporaryConfigStore = {
  isLoading: boolean;
  updateLoading: (isLoading: boolean) => void;
};

export const useTemporaryConfigStore = create<TemporaryConfigStore>()(
  immer((set, get) => ({
    isLoading: false,
    updateLoading: (isLoading) => {
      set((state) => {
        state.isLoading = isLoading;
      });
    },
  }))
);
